import {useServices} from "../../features/services/redux/services.hook";
import React from "react";
import Typography from "@material-ui/core/Typography";
import {Checkbox, Divider, FormControlLabel, Grid, LinearProgress, Tooltip} from "@material-ui/core";
import {OrderEngineStepActions} from "./OrderEngineStepActions";
import {FindAvailabilityStepProps} from "../types";
import {InfoOutlined} from "@material-ui/icons";

export function ServicesStep(props: FindAvailabilityStepProps<string[]>) {
    const services = useServices();

    const [selectedServicesIds, setSelectedServicesIds] = React.useState<string[]>(props.initialValue ?? []);

    const addServiceId = (id: string) => setSelectedServicesIds(p => [...p, id]);
    const removeServiceId = (id: string) => setSelectedServicesIds(p => p.filter((mId) => mId !== id));

    return (
        services.length === 0
            ? (
               <LinearProgress/>
            )
            : (
                <div>
                    <Typography color={"textSecondary"} style={{display: 'inline-flex', alignItems: "center"}}>
                        Für unsere Gartenhilfen berechnen wir 23 € pro Stunde <Tooltip title={<Typography>Zwei volle Stunden fallen mindestens an, damit sich die Anfahrt lohnt, danach wird im Viertelstundentakt abgerechnet.
                        Pro Stunde fallen 23 € inkl. Steuer an. Ist der Einsatz beendet, erhalten Sie eine Rechnung von uns.</Typography>}><InfoOutlined style={{marginLeft: 8}} color="primary" fontSize="small"/></Tooltip>
                    </Typography>
                    <Divider style={{marginBottom: 16, marginTop: 8}}/>
                    <Grid container spacing={2}>
                        {services.filter((s) => s.active).map((service) => (
                            <Grid item xs={12} md={3} key={"service-grid-item-" + service.id}>
                                <FormControlLabel
                                    style={{alignItems: "flex-start"}}
                                    control={
                                        <Checkbox
                                            style={{margin: 0, padding: "0 8px 0 0"}}
                                            checked={selectedServicesIds.includes(service.id)}
                                            onChange={(_event, checked) => checked
                                                ? addServiceId(service.id)
                                                : removeServiceId(service.id)
                                            }
                                        />
                                    }
                                    label={
                                        <div>
                                            <Typography variant="inherit">
                                                {service.name}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                {service.subtitle}
                                            </Typography>
                                        </div>
                                    }
                                />
                            </Grid>
                        ))}
                    </Grid>
                    <OrderEngineStepActions
                        onClickNext={selectedServicesIds.length > 0 ? () => props.onNext(selectedServicesIds) : undefined}
                        lastStep={false}
                    />
                </div>
            )
    )
}
